/** 账号系统： 短信验证码类型 */
export enum IPivotMobileCaptchas {
  /** 注册 */
  register = 1,
  /** 修改手机号 */
  modifyPhoneNumber,
  /** 重置密码 */
  resetPassword,
  /** 微信绑定 */
  weChatBinding,
  /** 验证码登录 */
  login,
  /** 绑定手机号 */
  phoneNumberBinding,
  /** 变更企业超管 */
  changeEnterpriseSupervision
}

export enum IGetMobileCaptchaState {
  SUCCESS = 1, // 获取成功
  SECURITY_RESTRICTIONS = 2, // 验证码获取次数间隔少于 60 秒
  UNKONW = 3 // 未知错误
}
